import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  lines3g90sq0zeq43v as lines,
  isBlank1dvkhjjvox3p0 as isBlank,
} from './Strings.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../collections/ArrayListJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../Unit.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../collections/Iterables.mjs';
import {
  minOrNull1g8m0136x75mg as minOrNull,
  joinTo3lkanfaxbzac2 as joinTo,
} from '../collections/_Collections.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from '../collections/CollectionsKt.mjs';
import { checkIndexOverflow3frtmheghr0th as checkIndexOverflow } from '../collections/collectionJs.mjs';
import { drop336950s126lmj as drop } from './_Strings.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from './StringBuilderJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../js/charSequenceJs.mjs';
import { isWhitespace25occ8z1ed1s9 as isWhitespace } from './charJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function trimIndent(_this__u8e3s4) {
  return replaceIndent(_this__u8e3s4, '');
}
function replaceIndent(_this__u8e3s4, newIndent) {
  newIndent = newIndent === VOID ? '' : newIndent;
  var lines_0 = lines(_this__u8e3s4);
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = lines_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(element)) {
      destination.v(element);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList().u(collectionSizeOrDefault(destination, 10));
  var _iterator__ex2g4s_0 = destination.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var item = _iterator__ex2g4s_0.o1();
    var tmp$ret$4 = indentWidth(item);
    destination_0.v(tmp$ret$4);
  }
  var tmp0_elvis_lhs = minOrNull(destination_0);
  var minCommonIndent = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  var tmp2 = _this__u8e3s4.length + imul(newIndent.length, lines_0.p1()) | 0;
  // Inline function 'kotlin.text.reindent' call
  var indentAddFunction = getIndentFunction(newIndent);
  var lastIndex = get_lastIndex(lines_0);
  // Inline function 'kotlin.collections.mapIndexedNotNull' call
  // Inline function 'kotlin.collections.mapIndexedNotNullTo' call
  var destination_1 = ArrayList().w();
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var _iterator__ex2g4s_1 = lines_0.m1();
  while (_iterator__ex2g4s_1.n1()) {
    var item_0 = _iterator__ex2g4s_1.o1();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    var tmp;
    if ((index_0 === 0 || index_0 === lastIndex) && isBlank(item_0)) {
      tmp = null;
    } else {
      var tmp0_safe_receiver = drop(item_0, minCommonIndent);
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_0 = indentAddFunction(tmp0_safe_receiver);
      }
      var tmp1_elvis_lhs = tmp_0;
      tmp = tmp1_elvis_lhs == null ? item_0 : tmp1_elvis_lhs;
    }
    var tmp0_safe_receiver_0 = tmp;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_1.v(tmp0_safe_receiver_0);
    }
  }
  return joinTo(destination_1, StringBuilder().bc(tmp2), '\n').toString();
}
function indentWidth(_this__u8e3s4) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.text.indexOfFirst' call
    var inductionVariable = 0;
    var last = charSequenceLength(_this__u8e3s4) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var it = charSequenceGet(_this__u8e3s4, index);
        if (!isWhitespace(it)) {
          tmp$ret$1 = index;
          break $l$block;
        }
      }
       while (inductionVariable <= last);
    tmp$ret$1 = -1;
  }
  // Inline function 'kotlin.let' call
  var it_0 = tmp$ret$1;
  return it_0 === -1 ? _this__u8e3s4.length : it_0;
}
function getIndentFunction(indent) {
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(indent) === 0) {
    tmp = getIndentFunction$lambda;
  } else {
    tmp = (line) => indent + line;
  }
  return tmp;
}
function getIndentFunction$lambda(line) {
  return line;
}
//region block: exports
export {
  trimIndent as trimIndent1qytc1wvt8suh,
};
//endregion

//# sourceMappingURL=Indent.mjs.map
